import React, {useEffect, useState} from 'react';
import useApi from '../../utils/useApi';

const PrintableForm = ({ uid, onPrintClose, type = null, year = null, blank = false }) => {
    const [form, setForm] = useState(null);
    const { getClientTaxQuestionnaire, printClient } = useApi();

    useEffect(() => {
        const initializeForm = async () => {
            try {
                let data = {
                    year: year
                }

                if(blank){
                    data.blank = true;
                }

                const response = await getClientTaxQuestionnaire(uid, 1, data);
                setForm(response.form);
            }
            catch (error) {
                console.error('Failed to fetch form:', error);
            }
        };

        const initializeAnyForm = async () => {
            let response;

            switch (type) {
                case 'clientForm':
                    response = await printClient(uid);
                    setForm(response.form);
                    break;
                default:
                    initializeForm();
            }
        }

        if (type !== null) {
            initializeAnyForm();
        } else {
            initializeForm();
        }

    }, [uid, getClientTaxQuestionnaire]);

    const printDiv = () => {
        const divToPrint = document.getElementById('print-sec');
        if (!divToPrint) return;

        const newWin = window.open('', 'Print-Window');
        if (!newWin) return;

        newWin.document.open();
        newWin.document.write(`
      <!DOCTYPE html>
      <html>
        <head>
          <style>
            @page {
              size: legal;
              margin-left: 3cm;
              margin-right: 3cm;
            }
            body {
              font-family: Arial, sans-serif;
            }
            .print-container {
              max-width: 768px;
              margin: auto;
            }
            table {
              width: 100%;
              border-collapse: collapse;
              margin-top: 20px;
            }
            th, td {
              padding: 8px;
              border: 1px solid #555;
              text-align: left;
            }
            tr.header-row td {
              background-color: #f5f5f5;
              font-weight: bold;
            }
            .form-heading {
              margin: 20px 0;
              font-size: 1.5rem;
              padding: 10px 0;
              border-bottom: 2px solid #555;
            }
            .form-subheader {
              margin: 10px 0;
              padding: 10px;
              background-color: #f9f9f9;
            }
            .new-section {
              margin-top: 2rem;
            }
            .full-width {
              width: 100%;
            }
          </style>
        </head>
        <body onload="window.print()">
          <div class="print-container">
            ${divToPrint.innerHTML}
          </div>
        </body>
      </html>
    `);
        newWin.document.close();

        setTimeout(() => {
            newWin.close();
            onPrintClose();
        }, 369);
    };

    useEffect(() => {
        if (form) {
            printDiv();
        }
    }, [form]);

    const renderField = (field, key) => {
        const fieldLabel = field.label.charAt(0).toUpperCase() + field.label.slice(1).toLowerCase();

        switch (field.type) {
            case 'header':
                return (
                    <tr key={key} style={{display: 'flex'}} className="header-row">
                        <td  style={{ width: '100%', minWidth: '100%', display: 'inline-block', boxSizing: 'border-box' }}>
                            <h2 className="form-heading">{fieldLabel}</h2>
                        </td>
                    </tr>
                );

            case 'paragraph':
                return (
                    <tr key={key} style={{display: 'flex', boxSizing: 'border-box'}}>
                        <td  style={{ width: '100%', minWidth: '100%', display: 'inline-block', boxSizing: 'border-box' }}>
                            <div
                                className="form-subheader"
                                dangerouslySetInnerHTML={{ __html: field.label }}
                            />
                        </td>
                    </tr>
                );

            default:
                return (
                    <tr key={key} style={{display: 'flex'}}>
                        <td style={{ width: '50%', minWidth: '50%', display: 'inline-block', boxSizing: 'border-box' }}>{fieldLabel}</td>
                        <td style={{ width: '50%', minWidth: '50%', display: 'inline-block', boxSizing: 'border-box' }}>{field.value || ''}</td>
                    </tr>
                );
        }
    };

    if (!form) {
        return <div className="text-center p-4">Loading form...</div>;
    }

    return (
        <div className="w-full max-w-3xl mx-auto">
            <div className="space-y-4">
                <div id="print-sec">
                    <table className="w-full border-collapse">
                        <tbody>
                        {form.fields.map((field, key) => renderField(field, key))}
                        </tbody>
                    </table>
                </div>

                <button
                    onClick={printDiv}
                    className="px-4 py-2 bg-gray-500 text-white rounded hover:bg-gray-600 transition-colors"
                >
                    Print Form
                </button>
            </div>
        </div>
    );
};

export default PrintableForm;
